import React from 'react';
import { BellIcon, CreditCardIcon } from 'lucide-react';

type ReminderFilter = 'all' | 'reminders' | 'payments';

interface RemindersFilterChipsProps {
  activeFilter: ReminderFilter;
  onChange: (filter: ReminderFilter) => void;
}

export function RemindersFilterChips({ activeFilter, onChange }: RemindersFilterChipsProps) {
  return (
    <div className="flex gap-2 px-4 py-3 bg-gray-50 border-b border-gray-200">
      <FilterChip
        label="All"
        active={activeFilter === 'all'}
        onClick={() => onChange('all')}
      />
      <FilterChip
        label="Reminders"
        icon={<BellIcon className="w-4 h-4" />}
        active={activeFilter === 'reminders'}
        onClick={() => onChange('reminders')}
      />
      <FilterChip
        label="Payments"
        icon={<CreditCardIcon className="w-4 h-4" />}
        active={activeFilter === 'payments'}
        onClick={() => onChange('payments')}
      />
    </div>
  );
}

interface FilterChipProps {
  label: string;
  icon?: React.ReactNode;
  active: boolean;
  onClick: () => void;
}

function FilterChip({ label, icon, active, onClick }: FilterChipProps) {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors flex items-center gap-1.5 ${
        active
          ? 'bg-[#5B8E87] text-white'
          : 'bg-white text-gray-600 border border-gray-300 hover:bg-gray-100'
      }`}
    >
      {icon}
      {label}
    </button>
  );
}
